import { FC } from 'react';

import YShapeNorth from '../../../../../../../assets/icons/shapes/y-shape/y-shape-1.svg?react';
import YShapeEast from '../../../../../../../assets/icons/shapes/y-shape/y-shape-2.svg?react';
import YShapeSouth from '../../../../../../../assets/icons/shapes/y-shape/y-shape-3.svg?react';
import YShapeWest from '../../../../../../../assets/icons/shapes/y-shape/y-shape-4.svg?react';
import { Himmelretning } from '../../../../../utils/registerEnums';

import { ShapeProps } from './types';

export const YShape: FC<ShapeProps> = ({ direction }) => {
  switch (direction) {
    case Himmelretning.Nord:
      return <YShapeNorth />;
    case Himmelretning.Ost:
      return <YShapeEast />;
    case Himmelretning.Sor:
      return <YShapeSouth />;
    case Himmelretning.Vest:
      return <YShapeWest />;

    default:
      return <YShapeNorth />;
  }
};
